export { LandingRoute as default } from '../components/LandingRoute';
